import PropTypes from "prop-types";
import React from "react";

const SectionHeading = ({ title, subtitle }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
    <div style={{ fontSize: "14px", lineHeight: "20px", fontWeight: 600, color: "var(--sl-text-primary)" }}>{title}</div>
    {subtitle ? <div style={{ fontSize: "12px", lineHeight: "18px", color: "var(--sl-text-quaternary)" }}>{subtitle}</div> : null}
  </div>
);

SectionHeading.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

SectionHeading.defaultProps = { subtitle: null };

export default SectionHeading;
